import { IAppConfig } from './app.config.base';
import { StagingConfig } from './app.config.staging';
import { ProductionConfig } from './app.config.prod';

// Adding these logs to check the values in different env
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_ENV:', process.env.REACT_APP_ENV);

const isProduction = process.env.REACT_APP_ENV === 'production';

export const AppConfig: IAppConfig = isProduction ? ProductionConfig : StagingConfig;
